import { z } from 'zod';

/** Valeurs du formulaire « Ajout d'un véhicule dans votre flotte ». */
export interface AddFleetValues {
    id: number;
    id_tiers?: number | string;
    type: string;
    marque: string;
    cylindree: string;
    vehicule: string;
    modele: string;
    sra: string;
    alimentation: string;
    date_mec: string;
    date_achat: string;
    immatriculation: string;
    assistance: string;
    file: File | null;
}

const REQUIRED_FIELDS = [
    'type',
    'marque',
    'cylindree',
    'modele',
    'date_mec',
    'date_achat',
    'immatriculation',
    'assistance',
    'file',
] as const;

/** Contrôle de l'ajout d'un véhicule (ancien `AddFleet/validate.js`). */
export const addFleetSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Record<string, unknown>;
    const errors: Record<string, string> = {};

    REQUIRED_FIELDS.forEach((field) => {
        if (!v[field]) {
            errors[field] = 'Ce champ est obligatoire';
        }
    });

    if (v.immatriculation && !/^[a-zA-Z]{2} ?-?[0-9]{3} ?-?[a-zA-Z]{2}$/.test(String(v.immatriculation))) {
        errors.immatriculation = "Plaque d'immatriculation non valide";
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
